export default __webpack_public_path__ + "static/media/portfolio-53.7dddb9c0.jpg";